function distanceXY(a, b) {
  // Computes the distance in the X-Y plane of points a and b
  // a, b: Either Vector2 or Vector3
  return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
}

function findHeight(face_lmarks, lmark1, lmark2) {
  let distance = 0;
  for (let i = 0; i < lmark1.length; i += 1) {
    distance += distanceXY(face_lmarks[lmark1[i]], face_lmarks[lmark2[i]]);
  }
  distance /= lmark1.length;
  return distance;
}

function find_if_mouth_open(
  upper_lips_height,
  lower_lips_height,
  mouth_height,
  threshold = 1.0
) {
  return (
    mouth_height > Math.max(upper_lips_height, lower_lips_height) * threshold
  );
}

function isMouthOpen(lcsm) {
  const upper_lips_top_lmakrs = [
    "upper_lip_top_L1",
    "upper_lip_top_L2",
    "upper_lip_top_M",
    "upper_lip_top_R1",
    "upper_lip_top_R2",
  ];

  const upper_lips_bottom_lmakrs = [
    "upper_lip_bottom_L1",
    "upper_lip_bottom_L2",
    "upper_lip_bottom_M",
    "upper_lip_bottom_R1",
    "upper_lip_bottom_R2",
  ];

  const lower_lips_top_lmakrs = [
    "lower_lip_top_L1",
    "lower_lip_top_L2",
    "lower_lip_top_M",
    "lower_lip_top_R1",
    "lower_lip_top_R2",
  ];

  const lower_lips_bottom_lmakrs = [
    "lower_lip_bottom_L1",
    "lower_lip_bottom_L2",
    "lower_lip_bottom_M",
    "lower_lip_bottom_R1",
    "lower_lip_bottom_R2",
  ];

  const upper_lips_height = findHeight(
    lcsm,
    upper_lips_top_lmakrs,
    upper_lips_bottom_lmakrs
  );

  const lower_lips_height = findHeight(
    lcsm,
    lower_lips_top_lmakrs,
    lower_lips_bottom_lmakrs
  );

  const mouth_height = findHeight(
    lcsm,
    upper_lips_bottom_lmakrs,
    lower_lips_top_lmakrs
  );

  const threshold = 0.45;

  const is_mouth_open = find_if_mouth_open(
    upper_lips_height,
    lower_lips_height,
    mouth_height,
    threshold
  );

  return is_mouth_open;
}

export default isMouthOpen;
